import { Badge } from '@/components/ui/badge.js';
import { pluralize } from '@/lib/string-utils.js';

export function ReservedPoolsBadge({
  pools,
  coachId,
}: {
  pools: readonly { id: string; title: string }[];
  coachId: string;
}) {
  if (pools.length === 0) {
    return null;
  }

  const label = `Reserved ${pools.length} ${pluralize(pools.length, 'pool', 'pools')}`;
  const names = pools.map((pool) => pool.title).join(', ');

  return (
    <Badge
      variant="secondary"
      className="mt-1 w-fit border-amber-200 bg-amber-50 px-2 py-0 font-normal text-amber-900 hover:bg-amber-50"
      title={names}
      data-testid={`teachers-availabilities-table-badge-reserved-pools-${coachId}`}
    >
      {label}
      <span className="sr-only">: {names}</span>
    </Badge>
  );
}
